import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const WebSettingGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (isLoggedIn && user && user.canViewWebSetting === false) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

WebSettingGuard.propTypes = {
  children: PropTypes.node,
};

export default WebSettingGuard;
